export const WarningObjectSchema = {
    warning: "",
    code: "",
};

export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let warning = Object.assign({}, WarningObjectSchema, {
        message: requestData.message,
        code: requestData.code,
    });

    return warning;
}
